import { renewSubscription } from '../Funnel/subscription';

export function renew(planId) {
  return async (dispatch) => {
    dispatch({ type: 'RENEW_SUBSCRIPTION' });
    const subsInfo = { plan: planId };
    return dispatch(renewSubscription(subsInfo)).then(
      result => dispatch({ type: 'RENEW_SUBSCRIPTION_SUCCESS', result: result.subscription }),
      error => dispatch({ type: 'RENEW_SUBSCRIPTION_FAILURE', error: error.message })
    );
  };
}

const initialState = {
  isRenewing: false,
  isRenewingError: false,
  isRenewingSuccess: false,
  renewalErrorMessage: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'RENEW_SUBSCRIPTION':
      return {
        ...state,
        isRenewing: true,
      };
    case 'RENEW_SUBSCRIPTION_SUCCESS':
      return {
        ...state,
        isRenewing: false,
        isRenewingSuccess: true,
      };
    case 'RENEW_SUBSCRIPTION_FAILURE':
      return {
        ...state,
        isRenewing: false,
        isRenewingError: true,
        renewalErrorMessage: action.error
      };
    case 'RENEW_SUBSCRIPTION_RESET': {
      return {
        ...state,
        ...initialState,
      };
    }
    default:
      return state;
  }
  return state;
}
